module.exports = __webpack_public_path__ + "img/1568973852.cbaa53f5.jpg";